import { takeLatest, put, select } from "redux-saga/effects";
import { createReducer, makeAction, makeKeys, urlWithPrefix } from "./helper";
import { httpPost, httpGet, httpDelete, httpPut } from "../core/restClient";
import { appLoading, appLoaded, toastError, toastSuccess } from "./app";
import {
  homePath,
  purchaseRequisitionPath,
  purchaseRequisitionEditPath,
  purchaseRequisitionDetailPath,
} from "../routes";
import { clearOtherProject, getProjectByCompany } from "./goa";
import {
  getUnits,
  getCurrencies,
  getPrTypes,
  getPrCategories,
  getMaterialGroups,
  getBudgetTypes as getBudgetTypesOption,
  getAccountAssignments,
  getPurchasingOrgs,
  getPlants,
  getStorageLocations,
  getPurchasingGroups,
  getGlAccounts,
  getCostCenter,
  getOrders,
  getCompanies,
  getCustomers,
  getAssets,
  getProfitCenters,
} from "./options";
import {
  getMappingWbsAssets,
  getMappingOderGlAccounts,
  getMappingPrItemFields,
  getMappingPurchasingGroups,
  getMappingCompanyPlants,
  getMappingPlantStorageLocations,
} from "./mappingData";
import { getHrmsMembers, getAllMembers } from "./member";
import { getGoaItem } from "./goa";
import r from "reactotron-react-js";

const GET_PR_MENUS = makeKeys("GET_PR_MENUS");
const GET_GL_ACCOUNT = makeKeys("GET_GL_ACCOUNT");
const GET_ATTACHMENT_TYPES = makeKeys("GET_ATTACHMENT_TYPES");
const GET_PR_DETAIL = makeKeys("GET_PR_DETAIL");
const GET_PR_APPROVER_ACTION = makeKeys("GET_PR_APPROVER_ACTION");
const GET_PR_WORKFLOW_APPROVER_VIEW = makeKeys("GET_PR_WORKFLOW_APPROVER_VIEW");
const FETCH_PR_LIST = makeKeys("FETCH_PR_LIST");
const SHOW_PR_ITEM_MODAL = "SHOW_PR_ITEM_MODAL";
const USER_SN = "USER_SN";
const K2_ERROR = "K2_ERROR";
const EMAIL_LOOP = "EMAIL_LOOP";
const SELECT_SUBCATEGORY = "SELECT_SUBCATEGORY";
const GET_PR_WORKFLOW_APPROVER = makeKeys("GET_PR_WORKFLOW_APPROVER");
const CREATE_PR = makeKeys("CREATE_PR");
const UPDATE_PR = makeKeys("UPDATE_PR");
const UPLOAD_PR_ATTACHMENTS = makeKeys("UPLOAD_PR_ATTACHMENTS");
const APPROVER_PR_ACTION = makeKeys("APPROVER_PR_ACTION");
const SUBMIT_PR = makeKeys("SUBMIT_PR");
const RE_SUBMIT_PR = makeKeys("RE_SUBMIT_PR");
const GET_PR_FORM_DATA = makeKeys("GET_PR_FORM_DATA");
const DELETE_PR = makeKeys("DELETE_PR");
const VALIDATE_BUDGET = makeKeys("VALIDATE_BUDGET");
const INITIALIZE_EDIT_PR = makeKeys("INITIALIZE_EDIT_PR");
const INITIALIZE_DETAIL_PR = makeKeys("INITIALIZE_DETAIL_PR");
const GET_RECOMMEND_ITEMS = makeKeys("GET_RECOMMEND_ITEMS");
const GET_MATERIAL_DETAIL = makeKeys("GET_MATERIAL_DETAIL");
const PRDETAIL_CLEAR_DATA = "PRDETAIL_CLEAR_DATA";
const ADD_PR_SPECIAL_COMMENT = "ADD_PR_SPECIAL_COMMENT";
const GET_PR_DETAIL_BY_DOC_NO = makeKeys("GET_PR_DETAIL_BY_DOC_NO");
const CLEAR_PR_CANCEL_DETAIL = "CLEAR_PR_CANCEL_DETAIL";

export const getPrMenus = makeAction(GET_PR_MENUS.REQUEST);
export const getPRDetail = makeAction(
  GET_PR_DETAIL.REQUEST,
  "prId",
  "history",
  "isRefresh",
);
export const clearPRDetailData = makeAction(PRDETAIL_CLEAR_DATA);
export const getPRApproverAction = makeAction(
  GET_PR_APPROVER_ACTION.REQUEST,
  "prDocNumber",
);
export const getWorkflowApproverView = makeAction(
  GET_PR_WORKFLOW_APPROVER_VIEW.REQUEST,
  "prId",
);
export const getWorkflowApprover = makeAction(
  GET_PR_WORKFLOW_APPROVER.REQUEST,
  "data",
);
export const fetchPRList = makeAction(FETCH_PR_LIST.REQUEST, "search");
export const getGlAccount = makeAction(GET_GL_ACCOUNT.REQUEST, "subCategory");
export const getAttachmentTypes = makeAction(GET_ATTACHMENT_TYPES.REQUEST);
export const showPrItemModal = makeAction(
  SHOW_PR_ITEM_MODAL,
  "show",
  "isNew",
  "data",
  "submitData",
);
export const selectSubCategory = makeAction(SELECT_SUBCATEGORY, "subCategory");
export const createPr = makeAction(
  CREATE_PR.REQUEST,
  "data",
  "submit",
  "history",
  "showAppLoading",
  "onCreateFail",
);
export const updatePr = makeAction(
  UPDATE_PR.REQUEST,
  "data",
  "submit",
  "history",
  "showAppLoading",
  "onCreateFail",
);
export const uploadPrAttachments = makeAction(
  UPLOAD_PR_ATTACHMENTS.REQUEST,
  "id",
  "data",
  "submit",
  "comment",
  "history",
  "showAppLoading",
  "onCreateFail",
);
export const approverPRAction = makeAction(APPROVER_PR_ACTION.REQUEST, "data");
export const submitPr = makeAction(
  SUBMIT_PR.REQUEST,
  "id",
  "history",
  "onCreateFail",
);
export const reSubmitPr = makeAction(
  RE_SUBMIT_PR.REQUEST,
  "comment",
  "history",
  "onCreateFail",
);
export const getPrFormData = makeAction(
  GET_PR_FORM_DATA.REQUEST,
  "id",
  "history",
);
export const clearPrFormData = makeAction(GET_PR_FORM_DATA.SUCCESS, "data");
export const deletePr = makeAction(DELETE_PR.REQUEST, "id", "data", "history");
export const validateBudget = makeAction(
  VALIDATE_BUDGET.REQUEST,
  "data",
  "onGetBudgetSuccess",
);
export const initializeEditPR = makeAction(INITIALIZE_EDIT_PR.REQUEST);
export const initializeDetailPR = makeAction(INITIALIZE_DETAIL_PR.REQUEST);
export const getRecommendItems = makeAction(
  GET_RECOMMEND_ITEMS.REQUEST,
  "retry",
);
export const getMaterialDetail = makeAction(
  GET_MATERIAL_DETAIL.REQUEST,
  "code",
  "onGetMaterialSuccess",
  "retry",
);
export const addSpecialComment = makeAction(
  ADD_PR_SPECIAL_COMMENT,
  "id",
  "data",
  "history",
);
export const getPRDetailByDocNo = makeAction(
  GET_PR_DETAIL_BY_DOC_NO.REQUEST,
  "prId"
);
export const clearPRCancelDetail = makeAction(CLEAR_PR_CANCEL_DETAIL);

const getPrMenusSuccess = makeAction(GET_PR_MENUS.SUCCESS, "data");
const getPRDetailSuccess = makeAction(GET_PR_DETAIL.SUCCESS, "data");
const getPRApproverActionItemSuccess = makeAction(
  GET_PR_APPROVER_ACTION.SUCCESS,
  "data",
);
const getWorkflowApproverViewSuccess = makeAction(
  GET_PR_WORKFLOW_APPROVER_VIEW.SUCCESS,
  "data",
);
const fetchPRListSuccess = makeAction(FETCH_PR_LIST.SUCCESS, "data");
const getGlAccountSuccess = makeAction(GET_GL_ACCOUNT.SUCCESS, "data");
const getAttachmentTypesSuccess = makeAction(
  GET_ATTACHMENT_TYPES.SUCCESS,
  "data",
);
const getWorkflowApproverSuccess = makeAction(
  GET_PR_WORKFLOW_APPROVER.SUCCESS,
  "data",
);
const createPrSuccess = makeAction(CREATE_PR.SUCCESS, "data");
const updatePrSuccess = makeAction(UPDATE_PR.SUCCESS, "data");
const uploadPrAttachmentsSuccess = makeAction(UPLOAD_PR_ATTACHMENTS.SUCCESS);
const approverPRActionSuccess = makeAction(APPROVER_PR_ACTION.SUCCESS);
const setUserSN = makeAction(USER_SN, "data");
const setCheckK2Error = makeAction(K2_ERROR, "data");
const setEmailLoop = makeAction(EMAIL_LOOP, "data");
const submitPrSuccess = makeAction(SUBMIT_PR.SUCCESS, "data");
const reSubmitPrSuccess = makeAction(RE_SUBMIT_PR.SUCCESS, "data");
const getPrFormDataSuccess = makeAction(GET_PR_FORM_DATA.SUCCESS, "data");
const validateBudgetSuccess = makeAction(VALIDATE_BUDGET.SUCCESS, "data");
const getRecommendItemsSuccess = makeAction(
  GET_RECOMMEND_ITEMS.SUCCESS,
  "data",
);
const getPRDetailByDocNoSuccess = makeAction(
  GET_PR_DETAIL_BY_DOC_NO.SUCCESS,
  "data",
);

const getWorkflowApproverFailure = makeAction(GET_PR_WORKFLOW_APPROVER.FAILURE);
const getWorkflowApproverViewFailure = makeAction(
  GET_PR_WORKFLOW_APPROVER_VIEW.FAILURE,
);

const initial = {
  loading: false,
  menuLoading: false,
  menus: [],
  showPrItemModal: false,
  isNewPrItem: true,
  prDetail: { data: {}, loading: true },
  prItem: {},
  prList: {},
  approverAction: null,
  prEmailLoop: [],
  userSN: "",
  checkK2Error: null,
  glAccounts: [],
  glLoading: false,
  attachmentTypes: [],
  attachmentTypeLoading: false,
  subCategory: {},
  approvers: [],
  approverLoading: false,
  onSubmitItem: () => {},
  prFormData: {},
  budgets: [],
  validatingBudget: true,
  recommendItems: { data: [], loading: false },
};

const prApiPath = (path) =>
  path
    ? urlWithPrefix(`purchaseRequisitions/${path}`)
    : urlWithPrefix("purchaseRequisitions");
const multipartHeader = { "Content-Type": "multipart/form-data" };

function* getPRDetailRequest(action) {
  const { prId, history } = action.payload;
  let prDetail;
  let username = localStorage.getItem("username").toLowerCase();
  try {
    yield put(appLoading());
    prDetail = yield httpGet(urlWithPrefix(`purchaseRequisitions/${prId}`));
    if (prDetail.status === 200) {
      if (prDetail.data) {
        if (prDetail.data.deleted) {
          yield put(appLoaded());
          yield put(setCheckK2Error({ isError: false, msg: "" }));
          yield put(getPRDetailSuccess({}));
          yield put(getPRApproverActionItemSuccess(null));
          yield put(setUserSN(""));
          yield put(
            toastError("Document does not exist or document is deleted"),
          );
          history.push(purchaseRequisitionPath);
        } else if (
          [0, "0"].indexOf(prDetail.data.status) >= 0 &&
          username === prDetail.data.createdByUser.toLowerCase()
        ) {
          yield put(appLoaded());
          yield put(setCheckK2Error({ isError: false, msg: "" }));
          yield put(getPRDetailSuccess({}));
          yield put(getPRApproverActionItemSuccess(null));
          yield put(setUserSN(""));
          yield put(getPrFormData(prId, history));
          history.push(purchaseRequisitionEditPath(prId));
        } else if (
          [5, "5"].indexOf(prDetail.data.status) >= 0 &&
          (username === prDetail.data.createdByUser.toLowerCase() ||
            username === prDetail.data.requesterUser.toLowerCase())
        ) {
          yield put(appLoaded());
          yield put(setCheckK2Error({ isError: false, msg: "" }));
          yield put(getPRDetailSuccess({}));
          yield put(getPRApproverActionItemSuccess(null));
          yield put(setUserSN(""));
          yield put(getPrFormData(prId, history));
          history.push(purchaseRequisitionEditPath(prId));
        } else {
          const attachmentTypes = yield httpGet(prApiPath("attachmentTypes"));
          prDetail.data["attachmentTypes"] = attachmentTypes.data;
          // const resApproverView = yield httpGet(prApiPath(`workflowApproverView?prID=${prId}`))
          // yield put(getWorkflowApproverViewSuccess(resApproverView.data))
          yield put(getWorkflowApproverView(prDetail.data.id));
          // yield put(setEmailLoop(setDupEmailLoop(resApproverView.data)))
          //check K2 Error
          const checkK2Error = yield httpGet(
            `share/workflow/getErrorWorkflow?procInstID=${prDetail.data.procInstId}&subProcInstID=${prDetail.data.subProcInstId || 0}`,
          );
          if (checkK2Error.status === 200) {
            if (checkK2Error.data.success) {
              //Get SN
              const resSN = yield httpGet(
                `share/workflow/getK2SN?refDocNumber=${prDetail.data.documentNumber}`,
              );
              if (resSN.status === 200) {
                if (resSN.data.success) {
                  yield put(setCheckK2Error({ isError: false, msg: "" }));
                  yield put(setUserSN(resSN.data.message));
                  //Get Action
                  const resWorkflowAction = yield httpGet(
                    `share/workflow/getWorkflowActionItem?serialNumber=${resSN.data.message}`,
                  );
                  if (resWorkflowAction.data) {
                    yield put(
                      getPRApproverActionItemSuccess(resWorkflowAction.data),
                    );
                  }
                }
              }
            } else {
              yield put(
                setCheckK2Error({
                  isError: true,
                  msg: checkK2Error.data.message,
                }),
              );
              yield put(getPRDetailSuccess(prDetail.data));
              yield put(getPRApproverActionItemSuccess(null));
              yield put(setUserSN(""));
            }
          }
          yield put(getPRDetailSuccess(prDetail.data));
          yield put(appLoaded());
        }
      }
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(appLoaded());
      yield put(getPRDetail(prId, history));
    } else {
      if (prDetail && prDetail.status === 200) {
        if (prDetail.data) {
          yield put(setCheckK2Error({ isError: false, msg: "" }));
          yield put(getPRDetailSuccess(prDetail.data));
        }
      } else {
        yield put(setCheckK2Error({ isError: false, msg: "" }));
        yield put(getPRDetailSuccess({}));
        yield put(
          toastError(
            "Could not connect to server, please try again in a few minutes",
          ),
        );
      }
      yield put(getPRApproverActionItemSuccess(null));
      yield put(setUserSN(""));
      yield put(appLoaded());
    }
  }
}

function setDupEmailLoop(data) {
  const result = [];
  const map = new Map();
  let emailLoop = [];
  data.forEach((item, i) => {
    item.approval.forEach((iItem, ii, iArray) => {
      if (iItem.email.length > 0) {
        emailLoop.push({
          key: `${i}|${ii}`,
          text: `${iItem.displayName}${iItem.position ? `(${iItem.position})` : ""}`,
          value: iItem.email,
        });
      }
    });
  });
  for (const item of emailLoop) {
    if (!map.has(item.value)) {
      map.set(item.value, true); // set any value to Map
      result.push({
        key: item.key,
        text: item.text,
        value: item.value,
      });
    }
  }
  return result;
}

function* fetchPRListRequest(action) {
  const { search } = action.payload;
  try {
    yield put(appLoading());

    yield put(getWorkflowApproverViewSuccess([]));
    yield put(setEmailLoop([]));
    yield put(setCheckK2Error(null));
    yield put(getPRDetailSuccess({}));
    yield put(getPRApproverActionItemSuccess(null));
    yield put(setUserSN(""));

    const response = yield httpGet(prApiPath(), search);
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchPRListSuccess(response.data));
      }
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(fetchPRList(search));
    }

    if (e.data && e.data.message) {
      yield put(toastError(e.data.message));
    }

    yield put(appLoaded());
  }
}

function* getPrMenusRequest(action) {
  try {
    const response = yield httpGet(urlWithPrefix("purchaseRequisitions/menus"));
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPrMenusSuccess(response.data));
      }
    }
  } catch (e) {}
}

function* getGlAccountRequest(action) {
  const { subCategory } = action.payload;
  try {
    const response = yield httpGet(prApiPath(`glAccounts/${subCategory}`));
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getGlAccountSuccess(response.data));
      }
    }
  } catch (e) {}
}

function* getAttachmentTypesRequest(action) {
  try {
    const response = yield httpGet(prApiPath(`attachmentTypes`));
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAttachmentTypesSuccess(response.data));
      }
    }
  } catch (e) {}
}

function* getWorkflowApproverRequest(action) {
  const { data } = action.payload;
  const {
    createdByUser,
    requesterUser,
    companyCode,
    items,
    goaItemCode,
    isAsset,
    isIt,
    totalAmount,
    goaId,
    specialApprovalId,
    rentDays,
    specialReason,
    plant,
  } = data;

  const purchasingGroup =
    items && items.length ? items[0].purchasingGroup : null;
  const currency = items && items.length ? items[0].currency : null;
  const plantItem =
    items && items.length
      ? items[items.findIndex((i) => !i.deleted)].plant
      : null;

  try {
    let itemDel = items ? items.filter((x) => x.deleted === true) : [];
    if (items && items.length && itemDel.length !== items.length) {
      const response = yield httpGet(prApiPath(`workflowApprover`), {
        creater: createdByUser,
        requester: requesterUser,
        companycode: companyCode,
        purchGroup: purchasingGroup,
        goaItemCode,
        currency,
        isAsset,
        isIT: isIt,
        amount: totalAmount,
        goaId,
        specialApprovalId,
        days: rentDays,
        alternativeUser: "",
        specialReason,
        plant: plantItem,
      });
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getWorkflowApproverSuccess(response.data));
        }
      }
    } else {
      yield put(getWorkflowApproverFailure());
    }
  } catch (e) {
    yield put(toastError("Get workflow approver error"));
    yield put(getWorkflowApproverFailure());
  }
}

function* createPrRequest(action) {
  const { data, submit, history, showAppLoading, onCreateFail } =
    action.payload;
  try {
    yield put(appLoading("Save data."));
    const response = yield httpPost(prApiPath(), data);
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(clearOtherProject());
        yield put(getProjectByCompany(data.companyCode));
        yield put(createPrSuccess(response.data));

        const { id } = response.data;
        var attachmentsData = {};
        if (data.pr01) attachmentsData.pr01 = data.pr01;
        if (data.pr02) attachmentsData.pr02 = data.pr02;
        if (data.pr03) attachmentsData.pr03 = data.pr03;
        if (data.pr04) attachmentsData.pr04 = data.pr04;
        if (data.pr05) attachmentsData.pr05 = data.pr05;
        if (data.pr06) attachmentsData.pr06 = data.pr06;
        if (data.pr07) attachmentsData.pr07 = data.pr07;
        if (data.pr08) attachmentsData.pr08 = data.pr08;
        if (data.pr09) attachmentsData.pr09 = data.pr09;
        if (data.pr10) attachmentsData.pr10 = data.pr10;
        if (data.pr11) attachmentsData.pr11 = data.pr11;
        if (data.pr12) attachmentsData.pr12 = data.pr12;
        if (data.pr13) attachmentsData.pr13 = data.pr13;
        if (data.pr14) attachmentsData.pr14 = data.pr14;
        if (data.pr15) attachmentsData.pr15 = data.pr15;

        yield put(
          uploadPrAttachments(
            id,
            attachmentsData,
            submit,
            "",
            history,
            showAppLoading,
            onCreateFail,
          ),
        );
      }
    }
  } catch (e) {
    if (onCreateFail) {
      //enable ปุ่ม เมื่อ error
      onCreateFail();
    }
    yield put(appLoaded());
  }
}

function* updatePrRequest(action) {
  const { data, submit, history, showAppLoading, onCreateFail } =
    action.payload;
  try {
    yield put(appLoading("Save data."));
    const response = yield httpPut(prApiPath(data.id), data);
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(clearOtherProject());
        yield put(getProjectByCompany(data.companyCode));
        yield put(updatePrSuccess(response.data));

        const { id } = data;
        var attachmentsData = {};
        if (data.pr01) attachmentsData.pr01 = data.pr01;
        if (data.pr02) attachmentsData.pr02 = data.pr02;
        if (data.pr03) attachmentsData.pr03 = data.pr03;
        if (data.pr04) attachmentsData.pr04 = data.pr04;
        if (data.pr05) attachmentsData.pr05 = data.pr05;
        if (data.pr06) attachmentsData.pr06 = data.pr06;
        if (data.pr07) attachmentsData.pr07 = data.pr07;
        if (data.pr08) attachmentsData.pr08 = data.pr08;
        if (data.pr09) attachmentsData.pr09 = data.pr09;
        if (data.pr10) attachmentsData.pr10 = data.pr10;
        if (data.pr11) attachmentsData.pr11 = data.pr11;
        if (data.pr12) attachmentsData.pr12 = data.pr12;
        if (data.pr13) attachmentsData.pr13 = data.pr13;
        if (data.pr14) attachmentsData.pr14 = data.pr14;
        if (data.pr15) attachmentsData.pr15 = data.pr15;

        yield put(
          uploadPrAttachments(
            id,
            { ...attachmentsData, status: data.status },
            submit,
            data.comment,
            history,
            showAppLoading,
            onCreateFail,
          ),
        );
      }
    }
  } catch (e) {
    if (onCreateFail) {
      //enable ปุ่ม เมื่อ error
      onCreateFail();
    }
    yield put(appLoaded());
  }
}

function* uploadPrDocRequest(action) {
  const { id, data, submit, history, comment, showAppLoading, onCreateFail } =
    action.payload;
  let fileCount = 0;
  let countUploading = 1;
  let fileName = "";
  Object.keys(data).forEach((x) => {
    let object = data[x];
    if (Array.isArray(object)) {
      fileCount += object.length;
    }
  });

  try {
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      let keyName = keys[i];
      let object = data[keyName];
      if (Array.isArray(object)) {
        for (let ii = 0; ii < object.length; ii++) {
          let fileItem = object[ii];
          fileName = fileItem.path;
          yield put(
            appLoading(
              `Uploading File '${fileItem.path}' (${countUploading}/${fileCount})`,
            ),
          );
          let file = {};
          file[keyName] = [fileItem];
          yield httpPost(prApiPath(`${id}/attachments`), file, multipartHeader);
          countUploading++;
        }
      }
    }
    if (submit) {
      if ([5, "5"].indexOf(data.status || 0) >= 0) {
        yield put(reSubmitPr(comment, history, onCreateFail)); // case re-submit
      } else {
        yield put(submitPr(id, history, onCreateFail));
      }
    } else {
      yield put(toastSuccess("Save purchase requisition success."));
      yield put(appLoaded());
      history.push(purchaseRequisitionPath);
    }
    yield put(appLoaded());
  } catch (e) {
    yield put(
      toastError(
        `Upload Attachments fail on '${fileName}' (${countUploading}/${fileCount})`,
        true,
      ),
    );
    history.push(purchaseRequisitionEditPath(id));
    yield put(appLoaded());
  }
}

function* getWorkflowApproverViewRequest(action) {
  const { prId } = action.payload;
  try {
    const response = yield httpGet(
      prApiPath(`workflowApproverView?prID=${prId}`),
    );
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorkflowApproverViewSuccess(response.data));
      }
    }
  } catch (e) {
    yield put(toastError("Get workflow approver error"));
    yield put(getWorkflowApproverViewFailure());
  }
}

function* approverPRActionRequest(action) {
  const { data } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpPost(
      prApiPath(`${data.prId}/actionApproval`),
      {
        docId: data.prId,
        sn: data.SN,
        action: data.action,
        comment: data.comment,
        commentAttachments: data.commentAttachments,
      },
      multipartHeader,
    );
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        yield put(approverPRActionSuccess());
        yield put(getPRApproverActionItemSuccess(null));
        yield put(setUserSN(""));
        yield put(setCheckK2Error(null));
        yield put(getWorkflowApproverViewSuccess([]));
        yield put(setEmailLoop([]));
        if (data.history.location.search.includes("h=true")) {
          data.history.push(homePath);
        } else {
          data.history.push(purchaseRequisitionPath);
        }
        yield put(toastSuccess("Purchase requisition action success"));
      } else {
      }
    }
  } catch (e) {
    yield put(appLoaded());
    yield put(toastError("Purchase requisition action fail."));
  }
}

function* getPRApproverActionRequest(action) {
  const { prDocNumber } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpGet(
      `share/workflow/getK2SN?refDocNumber=${prDocNumber}`,
    );
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        const response2 = yield httpGet(
          `share/workflow/getWorkflowActionItem?serialNumber=${response.data.message}`,
        );
        if (response2.data) {
          yield put(getPRApproverActionItemSuccess(response.data));
        }
      }
    }
    yield put(appLoaded());
  } catch (e) {
    yield put(appLoaded());
  }
}

function* submitPrRequest(action) {
  const { id, history, onCreateFail } = action.payload;
  try {
    yield put(appLoading("Submitting data to approval."));
    const response = yield httpPost(prApiPath(`${id}/submit`));
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(submitPrSuccess(response.data));
        history.push(purchaseRequisitionPath);
        yield put(toastSuccess("Submit purchase requisition success."));
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message));
      history.push(purchaseRequisitionEditPath(id));
    } else {
      yield put(toastError("Submit data error!"));
      history.push(purchaseRequisitionEditPath(id));
    }

    if (onCreateFail) {
      onCreateFail();
    }
    yield put(appLoaded());
  }
}

function* reSubmitPrRequest(action) {
  const { comment, history, onCreateFail } = action.payload;
  const state = yield select();

  try {
    yield put(appLoading("Submitting data to approval."));
    const response = yield httpPost(prApiPath("reSubmit"), {
      docId: state.pr.prFormData.pr.id,
      sn: state.pr.prFormData.sn,
      comment: comment,
    });
    yield put(appLoaded());
    if (response.status === 200) {
      if (response.data) {
        yield put(reSubmitPrSuccess(response.data));
        history.push(purchaseRequisitionPath);
        yield put(toastSuccess("Submit purchase requisition success."));
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message));
    } else {
      yield put(toastError("Submit data error!"));
    }

    if (onCreateFail) {
      onCreateFail();
    }
    yield put(appLoaded());
  }
}

function* deletePrRequest(action) {
  const { id, data, history } = action.payload;
  try {
    yield put(appLoading("Deleting purchase requisition."));
    const response = yield httpDelete(prApiPath(`${id}`), data);
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        history.push(purchaseRequisitionPath);
        yield put(toastSuccess("Delete purchase requisition success."));
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message));
    } else {
      yield put(toastError("Delete purchase requisition error!"));
    }
    yield put(appLoaded());
  }
}

function* getPrFormDataRequest(action) {
  const { id, history } = action.payload;
  let username = localStorage.getItem("username").toLowerCase();
  try {
    yield put(appLoading("Load purchase requisition data."));
    const response = yield httpGet(prApiPath(`${id}/formData`));
    yield put(appLoaded());
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.pr.deleted) {
          history.push(purchaseRequisitionPath);
          yield put(
            toastError("Document does not exist or document is deleted"),
          );
        }
        if (
          ([0, "0"].indexOf(response.data.pr.status) >= 0 &&
            username === response.data.pr.createdByUser.toLowerCase()) ||
          ([5, "5"].indexOf(response.data.pr.status) >= 0 &&
            (username === response.data.pr.createdByUser.toLowerCase() ||
              username === response.data.pr.requesterUser.toLowerCase()))
        ) {
          yield put(getPrFormDataSuccess(response.data));
          yield put(getGoaItem(response.data.pr.goaId, "PurchaseRequisition"));
          yield put(getGlAccount(response.data.pr.menuSubCategory));
        } else {
          yield put(getPRDetail(response.data.pr.id, history));
          history.push(purchaseRequisitionDetailPath(response.data.pr.id));
        }
      }
    }
  } catch (e) {
    yield put(appLoaded());
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(appLoaded());
      yield put(getPrFormData(id, history));
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(`FormData:${e.data.message}`));
      } else {
        yield put(toastError("Get purchase requisition data error!"));
      }
    }
  }
}

function* validateBudgetRequest(action) {
  const { data, onGetBudgetSuccess } = action.payload;
  try {
    const response = yield httpPost(prApiPath(`validateBudgetPR`), data);
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onGetBudgetSuccess(response.data);
        yield put(validateBudgetSuccess(response.data));
      }
    }
  } catch (e) {
    onGetBudgetSuccess([]);
    yield put(validateBudgetSuccess([]));
  }
}

function* initializeEditPRRequest() {
  try {
    const state = yield select();
    if (!state.member.members.length) {
      // yield put(getHrmsMembers())
      yield put(getAllMembers());
    }
    if (!state.options.costCenters.data.length) {
      yield put(getCostCenter());
    }
    if (!state.options.orders.data.length) {
      yield put(getOrders());
    }
    if (!state.options.purchasingGroups.data.length) {
      yield put(getPurchasingGroups());
    }
    if (!state.options.glAccounts.data.length) {
      yield put(getGlAccounts());
    }
    if (!state.pr.attachmentTypes.length) {
      yield put(getAttachmentTypes());
    }
    if (!state.mappingData.companyPlants.data.length) {
      yield put(getMappingCompanyPlants());
    }
    if (!state.mappingData.plantStorageLocations.data.length) {
      yield put(getMappingPlantStorageLocations());
    }
    if (!state.mappingData.wbsAssets.data.length) {
      yield put(getMappingWbsAssets());
    }
    if (!state.mappingData.orderGlAccounts.data.length) {
      yield put(getMappingOderGlAccounts());
    }
    if (!state.pr.menus.length) {
      yield put(getPrMenus());
    }
    if (!state.options.units.data.length) {
      yield put(getUnits());
    }
    if (!state.options.currencies.data.length) {
      yield put(getCurrencies());
    }
    if (!state.options.prTypes.data.length) {
      yield put(getPrTypes());
    }
    if (!state.options.prCategories.data.length) {
      yield put(getPrCategories());
    }
    if (!state.options.materialGroups.data.length) {
      yield put(getMaterialGroups());
    }
    if (!state.options.budgetTypes.data.length) {
      yield put(getBudgetTypesOption());
    }
    if (!state.options.accountAssignments.data.length) {
      yield put(getAccountAssignments());
    }
    if (!state.options.purchasingOrgs.data.length) {
      yield put(getPurchasingOrgs());
    }
    if (!state.options.plants.data.length) {
      yield put(getPlants());
    }
    if (!state.options.storageLocations.data.length) {
      yield put(getStorageLocations());
    }
    if (!state.options.companies.data.length) {
      yield put(getCompanies());
    }
    if (!state.options.customers.data.length) {
      yield put(getCustomers());
    }
    if (!state.options.assets.data.length) {
      yield put(getAssets());
    }
    if (!state.mappingData.purchasingGroups.data.length) {
      yield put(getMappingPurchasingGroups());
    }
    if (state.mappingData.prItemFields.data.itemName.K === undefined) {
      yield put(getMappingPrItemFields());
    }
    if (!state.pr.recommendItems.data.length) {
      yield put(getRecommendItems());
    }
    if (!state.options.profitCenters.data.length) {
      yield put(getProfitCenters());
    }
  } catch (e) {
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    console.log(e);
  }
}

function* initializeDetailPRRequest() {
  try {
    const state = yield select();
    if (!state.options.budgetTypes.data.length) {
      yield put(getBudgetTypesOption());
    }
    if (!state.options.assets.data.length) {
      yield put(getAssets());
    }
    if (!state.options.purchasingOrgs.data.length) {
      yield put(getPurchasingOrgs());
    }
    if (!state.options.purchasingGroups.data.length) {
      yield put(getPurchasingGroups());
    }
    if (!state.options.units.data.length) {
      yield put(getUnits());
    }
    if (!state.options.currencies.data.length) {
      yield put(getCurrencies());
    }
    if (!state.options.accountAssignments.data.length) {
      yield put(getAccountAssignments());
    }
    if (!state.options.materialGroups.data.length) {
      yield put(getMaterialGroups());
    }
    if (!state.options.plants.data.length) {
      yield put(getPlants());
    }
    if (!state.options.storageLocations.data.length) {
      yield put(getStorageLocations());
    }
    if (!state.options.glAccounts.data.length) {
      yield put(getGlAccounts());
    }
    if (!state.options.costCenters.data.length) {
      yield put(getCostCenter());
    }
    if (!state.options.orders.data.length) {
      yield put(getOrders());
    }
    if (!state.options.profitCenters.data.length) {
      yield put(getProfitCenters());
    }
  } catch (e) {
    console.log(e);
  }
}

function* getRecommendItemsRequest(action) {
  const { retry } = action.payload;
  try {
    const response = yield httpGet(prApiPath(`recommendItems`));
    if (response.data) {
      yield put(getRecommendItemsSuccess(response.data));
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(getRecommendItemsSuccess([]));
    } else {
      yield put(getRecommendItems(retry ? retry + 1 : 1));
    }
  }
}

function* getMaterialDetailRequest(action) {
  const { code, onGetMaterialSuccess, retry } = action.payload;

  try {
    yield put(appLoading("Loading material data."));
    const response = yield httpGet("share/master/materialDetails", {
      materialCode: code,
    });
    if (response.data) {
      yield put(appLoaded());
      onGetMaterialSuccess(response.data);
    }
  } catch (e) {
    if (retry && retry > 3) {
      yield put(appLoaded());
      yield put(toastError("Get material data failure!"));
    } else {
      yield put(
        getMaterialDetail(code, onGetMaterialSuccess, retry ? retry + 1 : 1),
      );
    }
  }
}

function* addSpecialCommentRequest(action) {
  const { id, data, history } = action.payload;
  try {
    yield put(appLoading());
    const response = yield httpPost(
      `purchaseRequisitions/${id}/comment`,
      data,
      multipartHeader,
    );
    if (response.status === 200) {
      yield put(appLoaded());
      yield put(toastSuccess("Add comment success"));
      yield put(getPRDetail(id, history, true));
    }
  } catch (e) {
    yield put(appLoaded());
    yield put(toastError("Add comment fail"));
  }
}
function* getPRDetailByDocNoRequest(action) {
  const { prId } = action.payload;
  let prDetail;
  let username = localStorage.getItem("username").toLowerCase();
  try {
    yield put(appLoading());
    prDetail = yield httpGet(urlWithPrefix(`purchaseRequisitions/${prId}`));
    if (prDetail.status === 200) {
      if (prDetail.data) {
        if (prDetail.data.status != 4) {
          yield put(
            toastError(
              `Can't cancel this document, Because document ${prId} is ${prDetail.data.statusName}`,
            ),
          );
          yield put(getPRDetailByDocNoSuccess({}));
        } else {
          console.log('prdetail',prDetail)
          yield put(getPRDetailByDocNoSuccess(prDetail.data));
        }

        yield put(appLoaded());
      }
    }
  } catch (e) {
    if (
      e &&
      e.config &&
      e.config.headers &&
      e.config.headers.Authorization === "Bearer null"
    ) {
      yield put(appLoaded());
      yield put(getPRDetailByDocNo(prId));
    } else {
      if (prDetail && prDetail.status === 200) {
        if (prDetail.data) {
          yield put(setCheckK2Error({ isError: false, msg: "" }));
          yield put(getPRDetailSuccess(prDetail.data));
        }
      }
      if (e.data) {
        yield put(toastError(e.data.message));
      }
      yield put(appLoaded());
    }
  }
}

export function* watchPurchaseRequisitionSaga() {
  yield takeLatest(GET_PR_MENUS.REQUEST, getPrMenusRequest);
  yield takeLatest(GET_PR_DETAIL.REQUEST, getPRDetailRequest);
  yield takeLatest(GET_PR_APPROVER_ACTION.REQUEST, getPRApproverActionRequest);
  yield takeLatest(
    GET_PR_WORKFLOW_APPROVER_VIEW.REQUEST,
    getWorkflowApproverViewRequest,
  );
  yield takeLatest(
    GET_PR_WORKFLOW_APPROVER.REQUEST,
    getWorkflowApproverRequest,
  );
  yield takeLatest(FETCH_PR_LIST.REQUEST, fetchPRListRequest);
  yield takeLatest(GET_GL_ACCOUNT.REQUEST, getGlAccountRequest);
  yield takeLatest(GET_ATTACHMENT_TYPES.REQUEST, getAttachmentTypesRequest);
  yield takeLatest(CREATE_PR.REQUEST, createPrRequest);
  yield takeLatest(UPDATE_PR.REQUEST, updatePrRequest);
  yield takeLatest(UPLOAD_PR_ATTACHMENTS.REQUEST, uploadPrDocRequest);
  yield takeLatest(APPROVER_PR_ACTION.REQUEST, approverPRActionRequest);
  yield takeLatest(SUBMIT_PR.REQUEST, submitPrRequest);
  yield takeLatest(RE_SUBMIT_PR.REQUEST, reSubmitPrRequest);
  yield takeLatest(DELETE_PR.REQUEST, deletePrRequest);
  yield takeLatest(GET_PR_FORM_DATA.REQUEST, getPrFormDataRequest);
  yield takeLatest(VALIDATE_BUDGET.REQUEST, validateBudgetRequest);
  yield takeLatest(INITIALIZE_EDIT_PR.REQUEST, initializeEditPRRequest);
  yield takeLatest(INITIALIZE_DETAIL_PR.REQUEST, initializeDetailPRRequest);
  yield takeLatest(GET_RECOMMEND_ITEMS.REQUEST, getRecommendItemsRequest);
  yield takeLatest(GET_MATERIAL_DETAIL.REQUEST, getMaterialDetailRequest);
  yield takeLatest(ADD_PR_SPECIAL_COMMENT, addSpecialCommentRequest);
  yield takeLatest(GET_PR_DETAIL_BY_DOC_NO.REQUEST, getPRDetailByDocNoRequest);
}

export default createReducer(initial, (state) => ({
  [GET_PR_DETAIL.REQUEST]: (data) => {
    if (data.isRefresh) {
      return { ...state };
    } else {
      return {
        ...state,
        prDetail: { data: {}, loading: true },
        loading: true,
      };
    }
  },
  [GET_PR_DETAIL.SUCCESS]: (data) => {
    let username = localStorage.getItem("username").toLowerCase();
    let x = data.data;
    if (Object.keys(x).length) {
      if (x.status == 2 && x.requesterUser.toLowerCase() == username) {
        x.canComment = true;
      }
    }
    return {
      ...state,
      prDetail: { data: x, loading: false },
      loading: false,
    };
  },
  [USER_SN]: (data) => ({
    ...state,
    userSN: data.data,
  }),
  [K2_ERROR]: (data) => ({
    ...state,
    checkK2Error: data.data,
  }),
  [EMAIL_LOOP]: (data) => ({
    ...state,
    prEmailLoop: data.data,
  }),
  [FETCH_PR_LIST.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_PR_LIST.SUCCESS]: (data) => ({
    ...state,
    prList: data.data,
    loading: false,
  }),
  [GET_PR_APPROVER_ACTION.REQUEST]: () => ({
    ...state,
  }),
  [GET_PR_APPROVER_ACTION.SUCCESS]: (data) => ({
    ...state,
    approverAction: data.data,
  }),
  [GET_PR_WORKFLOW_APPROVER_VIEW.REQUEST]: () => ({
    ...state,
    approverLoading: true,
  }),
  [GET_PR_WORKFLOW_APPROVER_VIEW.SUCCESS]: (data) => ({
    ...state,
    approvers: data.data,
    approverLoading: false,
  }),
  [GET_PR_WORKFLOW_APPROVER_VIEW.FAILURE]: (data) => ({
    ...state,
    approvers: [],
    approverLoading: false,
  }),
  [GET_PR_MENUS.REQUEST]: () => ({
    ...state,
    menuLoading: true,
  }),
  [GET_PR_MENUS.SUCCESS]: (data) => ({
    ...state,
    menus: data.data,
    menuLoading: false,
  }),
  [GET_PR_MENUS.FAILURE]: () => ({
    ...state,
    menuLoading: false,
  }),
  [GET_GL_ACCOUNT.REQUEST]: () => ({
    ...state,
    glAccounts: [],
    glLoading: true,
  }),
  [GET_GL_ACCOUNT.SUCCESS]: (data) => ({
    ...state,
    glAccounts: data.data,
    glLoading: false,
  }),
  [GET_ATTACHMENT_TYPES.REQUEST]: () => ({
    ...state,
    attachmentTypes: [],
    attachmentTypeLoading: true,
  }),
  [GET_ATTACHMENT_TYPES.SUCCESS]: (data) => ({
    ...state,
    attachmentTypes: data.data,
    attachmentTypeLoading: false,
  }),
  [SHOW_PR_ITEM_MODAL]: (data) => ({
    ...state,
    showPrItemModal: data.show,
    isNewPrItem: data.isNew !== undefined ? data.isNew : true,
    onSubmitItem: data.submitData || (() => {}),
    prItem: data.data || {},
  }),
  [GET_PR_WORKFLOW_APPROVER.REQUEST]: () => ({
    ...state,
    approverLoading: true,
  }),
  [GET_PR_WORKFLOW_APPROVER.SUCCESS]: (data) => ({
    ...state,
    approvers: data.data,
    approverLoading: false,
  }),
  [GET_PR_WORKFLOW_APPROVER.FAILURE]: () => ({
    ...state,
    approvers: [],
    approverLoading: false,
  }),
  [CREATE_PR.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_PR.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_PR.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_PR.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPLOAD_PR_ATTACHMENTS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPLOAD_PR_ATTACHMENTS.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [APPROVER_PR_ACTION.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [APPROVER_PR_ACTION.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [SELECT_SUBCATEGORY]: (data) => ({
    ...state,
    subCategory: data.subCategory,
  }),
  [GET_PR_FORM_DATA.REQUEST]: () => ({
    ...state,
    prDataLoading: true,
  }),
  [GET_PR_FORM_DATA.SUCCESS]: (data) => ({
    ...state,
    prFormData: data.data,
    prDataLoading: false,
  }),
  [VALIDATE_BUDGET.REQUEST]: () => ({
    ...state,
    budgets: [],
    validatingBudget: true,
  }),
  [VALIDATE_BUDGET.SUCCESS]: (data) => ({
    ...state,
    budgets: data.data,
    validatingBudget: false,
  }),
  [GET_RECOMMEND_ITEMS.REQUEST]: () => ({
    ...state,
    recommendItems: { data: [], loading: false },
  }),
  [GET_RECOMMEND_ITEMS.SUCCESS]: (data) => ({
    ...state,
    recommendItems: { data: data.data, loading: true },
  }),
  [PRDETAIL_CLEAR_DATA]: (data) => ({
    ...state,
    recommendItems: { data: data.data, loading: true },
  }),
  [GET_PR_DETAIL_BY_DOC_NO.REQUEST]: (data) => {
    return {
      ...state,
      prDetail: { data: {}, loaded: false },
    };
  },
  [GET_PR_DETAIL_BY_DOC_NO.SUCCESS]: (data) => {
    let x = data.data;
    return {
      ...state,
      prDetail: { data: x, loaded: true },
    };
  },
  [CLEAR_PR_CANCEL_DETAIL]: () => ({
    ...state,
      prDetail: { data: {}, loaded: false },
  }),
}));
